import { render, staticRenderFns } from "./ChangeThemeButton.vue?vue&type=template&id=2ed5870b"
import script from "./ChangeThemeButton.vue?vue&type=script&lang=ts"
export * from "./ChangeThemeButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed5870b')) {
      api.createRecord('2ed5870b', component.options)
    } else {
      api.reload('2ed5870b', component.options)
    }
    module.hot.accept("./ChangeThemeButton.vue?vue&type=template&id=2ed5870b", function () {
      api.rerender('2ed5870b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChangeThemeButton.vue"
export default component.exports